import { Component, Input, OnInit } from '@angular/core';
import { BaseCmsComponent, ToastMessage } from '@kion/data-models';
import { ToastService } from '@kion/ui';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'kion-cms-promotion-banner',
  templateUrl: './promotion-banner.component.html',
  styleUrls: ['./promotion-banner.component.scss']
})
export class PromotionBannerComponent implements OnInit{
  @Input() component: BaseCmsComponent;

  isLink: boolean;
  isCode: boolean;

  constructor(
    private toastService: ToastService,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    if (this.component.linkTarget) {
      this.isLink = true
    }
    if (this.component.promotionCode) {
      this.isCode = true
    }
    if (!this.isLink && !this.isCode) {
     this.isCode = true
    }
  }

  copyCodeIfExist(): void {
    if (this.component.promotionCode) {
      const listener = (e: ClipboardEvent) => {
        e.clipboardData.setData('text/plain', this.component.promotionCode);
        e.preventDefault();
      };
      document.addEventListener('copy', listener);
      document.execCommand('copy');
      document.removeEventListener('copy', listener);
      this.toastService.show(
        {
          type: 'success',
          text: this.translateService.instant('toast.promotion.copy.success')
        }
      )
    }
  }
}
